module.exports = __webpack_public_path__ + "static/media/arrow-right.20d2b958.svg";